(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PublisherIbqDialogController', PublisherIbqDialogController);

    PublisherIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Publisher', 'Material'];

    function PublisherIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Publisher, Material) {
        var vm = this;

        vm.publisher = entity;
        vm.clear = clear;
        vm.save = save;
        vm.materials = Material.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publisher.id !== null) {
                Publisher.update(vm.publisher, onSaveSuccess, onSaveError);
            } else {
                Publisher.save(vm.publisher, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:publisherUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
